// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"451":"d43cbcb1","640":"eb591861","869":"70b81651"}[chunkId] + ".css";
};